import React from "react";
import Modal from "../UI/Modal";
import Button from "../UI/Button";

import { useDispatch, useSelector } from "react-redux";

import { popupActions } from "../../store/popup-slice";
import classes from "./AccommodationPopup.module.css";

import { quoteActions } from "../../store/quote-slice";

const AccommodationPopup = () => {
  const dispatch = useDispatch();
  const accommodationPopup = useSelector(
    (state) => state.popup.accommodationPopup
  );

  const FirstFloorSelection = () => {
    dispatch(
      quoteActions.setAccomPref({
        preference: "first",
      })
    );

    AccommodationPopupHide();
  };

  const GroundRoomSelection = () => {
    dispatch(
      quoteActions.setAccomPref({
        preference: "ground",
      })
    );

    AccommodationPopupHide();
  };

  const BambooRoomSelection = () => {
    dispatch(
      quoteActions.setAccomPref({
        preference: "bamboo",
      })
    );

    AccommodationPopupHide();
  };

  const NoPreference = () => {
    dispatch(
      quoteActions.setAccomPref({
        preference: "noPref",
      })
    );

    AccommodationPopupHide();
  };

  const AccommodationPopupHide = (event) => {
    dispatch(popupActions.setAccommodationPopupHide());
  };

  return (
    accommodationPopup && (
      <Modal onClose={AccommodationPopupHide}>
       
       <div>
          <h2>No Preference</h2>
          <center>
            <Button onClick={NoPreference} buttonText="Select" size="small" />
          </center>
          <p>No Preference (Any Room Type)</p>
        </div>
       
        <div className={classes.flexContainer}>
          <div className={classes.imgfirstfloor}></div>

          <div className={classes.description}>
            <h2>First Floor Upstairs Room</h2>
            <center>
              <Button
                onClick={FirstFloorSelection}
                buttonText="Select"
                size="small"
              />
            </center>
            <p>
              Settle into your own private sanctuary on the upstairs first floor with a
              communal balcony overlooking the pool, complete with spacious 26
              sqm floor plan.
            </p>
          </div>
        </div>
        <div className={classes.flexContainer}>
          <div className={classes.imggroundfloor}></div>
          <div className={classes.description}>
            <h2>Ground Floor Pool Side Room</h2>
            <center>
              <Button
                onClick={GroundRoomSelection}
                buttonText="Select"
                size="small"
              />
            </center>
            <p>
              Complete with spacious 30 sqm floor plan featuring a fresh colour palette with minimalist
              design and sliding patio doors for pool side access.
            </p>
          </div>
        </div>

        <div className={classes.flexContainer}>
          <div className={classes.imgbamboofloor}></div>
          <div className={classes.description}>
            <h2>Bamboo Haven Room</h2>
            <center>
              <Button
                onClick={BambooRoomSelection}
                buttonText="Select"
                size="small"
              />
            </center>
            <p>
              Complete with spacious 26 sqm floor plan, located close to the salt water plunge pool, offering a tranquil oasis.
            </p>
          </div>
        </div>


        <center>
          <Button onClick={AccommodationPopupHide} buttonText="Close" />
        </center>
      </Modal>
    )
  );
};

export default AccommodationPopup;
